import { Container } from "unstated";

import _ from "lodash";

class SetupContainer extends Container {
  constructor(serviceContainer, props = {}) {
    super(props);

    this.serviceContainer = serviceContainer;
    this.accountService = serviceContainer.accountService;

    this.state = {
      existingInfo: undefined
    };
  }

  getExistingInfo() {
    return this.state.existingInfo;
  }

  lookupExistingProfile(setupToken) {
    return this.accountService
      .lookupExistingProfile(setupToken)
      .then((result) => {
        this.setState({
          existingInfo: _.pick(result, [
            "firstName",
            "lastName",
            "email",
            "homePhoneNumber"
          ])
        });

        return result;
      });
  }

  activate(setupToken, data) {
    const payload = _.pick(data, [
      "firstName",
      "lastName",
      "email",
      "homePhoneNumber",
      "dateOfBirth",
      "password"
    ]);

    return this.accountService.activate(setupToken, payload).then((result) => {
      this.setState({ existingInfo: undefined });

      return result;
    });
  }
}

export { SetupContainer };
